if (!customElements.get('dog-infinite')) {
  customElements.define(
    'dog-infinite',
    class DogInfinite extends HTMLElement {
      connectedCallback() {
        this.grid = document.getElementById('product-grid');
        this.status = this.querySelector('.dog-infinite__status');
        this.bar = this.querySelector('.dog-infinite__bar span');
        this.pager = this.querySelector('.pagination-wrapper');
        if (this.pager) this.pager.classList.add('dog-infinite__pager');

        if (!this.dataset.next || !this.grid) return;

        this.observer = new IntersectionObserver(
          (entries) => {
            if (entries.some((entry) => entry.isIntersecting)) this.loadMore();
          },
          { rootMargin: '400px 0px' }
        );
        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      async loadMore() {
        if (this.loading || !this.dataset.next) return;
        this.loading = true;
        this.setAttribute('aria-busy', 'true');

        try {
          const url = new URL(this.dataset.next, window.location.origin);
          url.searchParams.set('section_id', this.dataset.section);
          const response = await fetch(url.toString());
          const text = await response.text();
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const nextGrid = doc.getElementById('product-grid');
          const nextInfinite = doc.querySelector('dog-infinite');

          if (nextGrid) {
            Array.from(nextGrid.children).forEach((child) => this.grid.appendChild(child));
          }

          if (nextInfinite?.dataset.next) {
            this.dataset.next = nextInfinite.dataset.next;
          } else {
            this.dataset.next = '';
            this.observer?.disconnect();
          }

          if (nextInfinite) {
            const nextStatus = nextInfinite.querySelector('.dog-infinite__status');
            const nextBar = nextInfinite.querySelector('.dog-infinite__bar span');
            if (this.status && nextStatus) this.status.textContent = nextStatus.textContent;
            if (this.bar && nextBar) this.bar.style.width = nextBar.style.width;
            const nextPager = nextInfinite.querySelector('.pagination-wrapper');
            if (this.pager && nextPager) this.pager.replaceWith(nextPager);
            this.pager = this.querySelector('.pagination-wrapper');
            if (this.pager) this.pager.classList.add('dog-infinite__pager');
          }

          const page = url.searchParams.get('page');
          const current = new URL(window.location.href);
          if (page) current.searchParams.set('page', page);
          history.replaceState(history.state, '', current.toString());
        } catch (error) {
          console.error(error);
          this.dataset.next = '';
        } finally {
          this.loading = false;
          this.removeAttribute('aria-busy');
        }
      }
    }
  );
}
